import request from "@/utils/request";

// 提出问题
export function deekseekAskProblem(data) {
  return request({
    url: "/ai/deekseek/v1/askProblem",
    method: "post",
    params: data,
  });
}

// 删除会话
export function deekseekDeleteSession(data) {
  return request({
    url: "/ai/deekseek/v1/deleteSession",
    method: "post",
    params: data,
  });
}

// 获取新会话id
export function getNewSessionId(data) {
  return request({
    url: `/ai/deekseek/v1/getNewSessionId`,
    method: "get",
    params: data,
  });
}

// 获取会话详细记录
export function getProblemList(data) {
  return request({
    url: `/ai/deekseek/v1/getProblemList`,
    method: "get",
    params: data,
  });
}

// 获取会话历史列表
export function getSessionHistoryList() {
  return request({
    url: `/ai/deekseek/v1/getSessionHistoryList`,
    method: "get",
  });
}
